export default __webpack_public_path__ + "static/media/crown.f01a1f02.svg";